import { ReactNode } from "react";
import Layout from "../components/Layout/Layout";

const Element = ({ page }: any) => {
    const withCustomLayout =
        page?.type?.getLayout ?? ((page: ReactNode) => <Layout>{page}</Layout>);

    return <>{withCustomLayout(page)}</>;
};

export default Element;
